import React, { Component } from 'react';
import '../../../../styles/variables.css';
import {Link} from 'react-router-dom';
import profile from '../../../../images/c_logo.png';
import '../DashboardAdmin.css';
import {connect} from 'react-redux';
import {startLogout} from '../../../../actions/auth_actions';
import logo from '../../../../images/logo.jpeg'

class Sidenav extends Component {

    state = {
        currentPage: ''
    }

    componentDidMount(){
        if(!!this.props.history.location.pathname){
            let currentPage = this.props.history.location.pathname.split('t/')[1];
            this.setState({
                currentPage: currentPage
            })
        }
    }

    onRouteChanged = () => {
        let currentPage = this.props.history.location.pathname.split('t/')[1];
        this.setState({
            currentPage : currentPage
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.history.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    signOut = () =>{
        this.props.logout();
        window.location.reload(true);
    }

    render(){
        return(
            <div className="sidenav">
                <div className="brand">
                    <Link id="brand-logo" to="/management/dashboard">
                        <div className="brand-nav shadow">
                            <div className="nav-title">
                                <img src={logo} alt="main-logo" className="main-logo"/>
                                <p className="powered">Powered by: <b className="by-">La pieza</b></p>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="admin-info">
                    <p className="admin-name">- Administrador -</p>
                </div>
                <div className="menu-items">
                    <Link className={`menu-item  ${this.state.currentPage === "vacancies" ? "current-page" : null}`} 
                    to="/management/vacancies">Agregar vacantes</Link>
                    <Link className={`menu-item  ${this.state.currentPage === "delete" ? "current-page" : null}`} 
                    to="/management/delete">Eliminar vacantes</Link>
                    <Link className={`menu-item  ${this.state.currentPage === "new-company" ? "current-page" : null}`} 
                    to="/management/new-company">Agregar empresas</Link>
                </div>
                <div className="logout">
                    <button type="button" className="a-logout" onClick={()=> { this.signOut() }}>Cerrar sesión</button>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    logout: () => (dispatch(startLogout()))
})
const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Sidenav);